define(function (require) {
    "use strict";

    var LE = require("app");
    var Logger = require('logger');
    var template = require("manager-templates/manageDomainsBoxItem.tmpl");
    var URLComponent = require("ui/urlComponent/URLComponent");
    var BaseModel = require("models/BaseModel");
    var InputField = require("ui/input-field/InputField");
    var ManageDomainsBoxItemView = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        ManageDomainsBoxItemView = Marionette.ItemView.extend({
            template:template,
            tagName: "div",
            className: "cb-content-row",
            ui:{
                urlWrapper:".cb-input-row-fields"
            },
            uiComponents:{
                urlInputField:{
                    type: InputField,
                    options: {
                        tabindex: 2,
                        permutation: InputField.Permutation.I,
                        placeholder: LE.translator.translate("LEManager.manage.domains.placeholder"),
                        el: "view.ui.urlWrapper",
                        value: "view._getUrl"
                    },
                    events:{
                        change:"_onUrlChange"
                    }
                }
            },
            events:{
                "click .cb-input-row-close-btn":"_closeCBItem"
            },

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            onClose: function() {
                this._onClose();
            },
            //</editor-fold>

            //<editor-fold desc="publicFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            //</editor-fold>

            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            _initialize:function (options) {
                this.logger = Logger.getLogger("LEManager");
                this.logger.info("Url condition box item initializing.", "ManageDomainsBoxItemView:initialize. options = " + options);
                this.channel = LEManager.media.channel("manageDomains");
            },

            _onRender: function() {
                this.logger.info("Url condition box item rendering.", "ManageDomainsBoxItemView:_onRender");
                this._bindEvents();
            },

            _bindEvents : function () {
                this.logger.debug("Init events of the view", "ManageDomainsBoxItemView:_onRender");
                this.listenTo(this.model, "validated:invalid", this._onValidatedInvalid);
            },

            _onUrlChange: function(componentId, eventName, value) {
                this.logger.debug("URl was changed", "ManageDomainsBoxItemView:_onUrlChange");
                this.model.set("url", value);
                this.channel.trigger("manageDomain:changed");
            },

            _onValidatedInvalid:function (model, errorObject) {
                this.logger.debug("Url condition box item validation failed", "ManageDomainsBoxItemView:_onValidatedInvalid", {
                    "errorObject": errorObject
                });

                if (_.has(errorObject, this.model.KEYS.URL)) {
                    this.uiComponents.urlInputField.setError(true, LE.translator.translate(errorObject[this.model.KEYS.URL]));
                }
            },

            _getUrl:function () {
                this.logger.debug("Get URL value", "ManageDomainsBoxItemView:_getUrl");
                return this.model.get("url");
            },

            _closeCBItem:function (ev) {
                this.logger.debug("Close the URL item", "ManageDomainsBoxItemView:_closeCBItem");
                ev.stopPropagation();
                this.trigger("close:clicked", this.model);
                this.channel.trigger("manageDomain:changed");
            },

            _hideErrors: function () {
                this.uiComponents.urlInputField.setError(false);
            },

            _onClose: function() {
                this.logger.debug("Close manage domain item", "ManageDomainsBoxItemView:_onClose");
                this._hideErrors();
            }
        });
    });

    return ManageDomainsBoxItemView;
});